import script from "./Completion2FooterButtons.vue?vue&type=script&lang=ts&setup=true"
export * from "./Completion2FooterButtons.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__